import TElogo from "../../../assets/images/dod_logo.png";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster } from "../../components/Toaster/Toster";
import { ToastContainer } from "react-toastify";
import BtnLoader from "../../components/Loader/btnLoader";
import { loginConfirmedAction } from "../../../store/actions/AuthActions";
import { useDispatch } from "react-redux";
import { userLoginApi } from "../../../services/apis/AuthService";
import deskImg from "../../../assets/images/DodUserLoginpannel/Desk iMAGE png.png";
import dodlogo from "../../../assets/images/DodUserLoginpannel/dodLogoSVG.svg";
import connectImg from "../../../assets/images/dod_connect.png";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from "react-device-detect";

const UserLoginTriEssense = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [informationIp, setInformationIp] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const deviceType = {
    type: isMobile
      ? "Mobile"
      : isTablet
      ? "Tablet"
      : isDesktop
      ? "Desktop"
      : "Unknown",
    os: isAndroid ? "Android" : isIOS ? "iOS" : "Other",
  };

  const validateFields = () => {
    const errorObj = { email: "", password: "" };
    let isError = false;
    if (!email) {
      errorObj.email = "Email is required";
      isError = true;
    }
    if (!password) {
      errorObj.password = "Password is required";
      isError = true;
    }
    setErrors(errorObj);
    return isError;
  };

  // Reset the specific error when the user starts typing
  const handleInputChange = (e, field) => {
    if (field === "email") {
      setEmail(e.target.value);
      if (submitted && errors.email) {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    } else if (field === "password") {
      setPassword(e.target.value);
      if (submitted && errors.password) {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }
  };

  // log activity-------------------------
  //   const SystemIp = async () => {
  //     try {
  //       await systemIpAddress()
  //         .then((response) => {
  //           passIpAddress(response?.data?.ip)
  //         })
  //     } catch (err) {
  //       console.log(err)
  //     }
  //   }

  //   const passIpAddress = async (ipv4) => {
  //     try {
  //       await pass_systemIpAddress(ipv4)
  //         .then((response) => {
  //           setInformationIp(response?.data)
  //         })
  //     } catch (err) {
  //       console.log(err)
  //     }
  //   }

  //   useEffect(() => {
  //     SystemIp();
  //   }, [])

  // const loggedActivity = async (id) => {
  //   const data = {
  //       id:id,
  //       ipAddress: informationIp?.query,
  //       lat: informationIp?.lat,
  //       long: informationIp?.lon,
  //       logType:'login',
  //       deviceType: JSON.stringify(deviceType),
  //       city: informationIp?.city,
  //       countryCode: informationIp?.countryCode,
  //       regionCode: informationIp?.region
  //   }
  //    try {
  //     await CreatelogActivityApi(data)
  //   } catch (err) {
  //      console.log(err)
  //   }
  // }

  const handleUserLogin = async (e) => {
    e.preventDefault();
    const isFormValid = validateFields();
    if (isFormValid) {
      return;
    }
    const stateData = {
      email: email,
      password: password,
    };
    setBtnLoading(true);
    try {
      const res = await userLoginApi(stateData);
      const resData = res?.data?.data;
      const user_id = resData?.data?.user?._id;
      if (resData?.success) {
        localStorage.setItem("tokens", JSON.stringify(resData?.data?.tokens));
        localStorage.setItem("token", JSON.stringify(resData?.data?.token));
        localStorage.setItem("user", JSON.stringify(resData?.data?.user));
        dispatch(loginConfirmedAction(resData?.data));
        //  loggedActivity(user_id)
        navigate("/dashboard");
      }
    } catch (err) {
      //console.log(err);
      Toaster.error(err.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="container-xl">
        <div className="user-login-video-section">
          {/* <video className="user-login-df-video" autoPlay muted loop controls={false}>
               <source src={dfVideo} type="video/mp4" />
              </video> */}
          <div className="overlay-section"></div>
        </div>

        <div className="main-content-box row mt-3">
          <div className="col-md-6 d-flex flex-column align-items-center align-items-lg-start user-login-left-section">
            <img className="user-login-logo" src={TElogo} alt="logo" />

            <img
              className="user-login-deskimg d-none d-md-block"
              src={deskImg}
              alt="logo2"
            />

            {/* <h4 className="login-welcome-text text-white">Welcome back User !</h4>
              <h1 className="user-login-text">Sign in</h1>

              <hr className="d-none d-sm-block login-bottom-line"/> */}
          </div>

          <div className="col-md-6 user-login-right-section mt-4 mt-sm-0">
            <div className="user-login-section">
              <form onSubmit={handleUserLogin}>
                <div className="mb-3">
                  <h1 className="user-login-text mb-0">Sign in</h1>
                  <h4 className="user-login-join-text text-white">
                    Join DOD Today! Visit us: dodindia.in.
                  </h4>
                </div>
                <div className="mb-3">
                  <label className="mb-1 text-white">
                    <strong>Email</strong>
                  </label>
                    <input
                      type="email"
                      className="form-control user-login-input-box"
                      value={email}
                      // onChange={(e) => setEmail(e.target.value)}
                      onChange={(e) => handleInputChange(e, "email")}
                      placeholder="Type Your Email Address"
                    />
                    {errors.email && (
                      <div className="text-danger fs-12">{errors.email}</div>
                    )}

                  <div className="mb-2">
                    <label className="mb-1 text-white">
                      <strong>Password</strong>
                    </label>
                  <div className="position-relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control user-login-input-box mb-1"
                      value={password}
                      placeholder="Type Your Password"
                      onChange={(e) => handleInputChange(e, "password")}
                    />
                    <span
                      className="user-eyeicon-div"
                      onClick={togglePasswordVisibility}>
                      {showPassword ? (
                        <IoMdEyeOff size={22}/>
                      ) : (
                        <IoEye size={22}/> 

                      )}
                    </span>
                    </div>
                  </div>
                  {errors.password && (
                    <div className="text-danger fs-12">{errors.password}</div>
                  )}
                </div>

                {props.successMessage && (
                  <div className="text-danger p-1 my-2">
                    {props.successMessage}
                  </div>
                )}

                <div className="row d-flex justify-content-between mt-0 mb-0">
                  <div className="mb-3">
                    <div className="d-flex justify-content-end form-check custom-checkbox ms-1 ps-0">
                      <Link className="text-white" to="/user/forgotpassword">
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn text-white btn-block user-login-btn">
                    {btnLoading && <BtnLoader />}
                    {/* Sign In */}
                    <img
                      className="user-login-connect-img"
                      src={connectImg}
                      alt="connect-img"
                    />
                  </button>
                </div>
              </form>

              <div className="text-center my-3">
                <div className="or-divider">
                  <span className="text-or">OR</span>
                </div>
              </div>

              <div className="d-flex justify-content-between gap-3">
                <Link className="text-white" to="/login">
                  Sign In as <span className="admin-staff-text">Admin</span>
                </Link>
                <Link className="text-white" to="/staff/login">
                  Sign In as <span className="admin-staff-text">Staff</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="bottom-section mt-4 mt-sm-0">
            <p className="user-login-bottom-text">
              D.O.D "Decade od Design" is a registered trademark of Tri Essence.{" "}
              <br />© 2025 Tri Essence
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLoginTriEssense;
